import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const ROUTE_TITLES: Record<string, string> = {
    '/dashboard': 'Dashboard',
    '/documents': 'Documents',
    '/documents/new': 'Add New Document',
    '/documents/dashboard': 'Document Dashboard',
    '/checklists': 'Checklists',
    '/checklists/templates': 'Checklist Templates',
    '/policies': 'Policies',
    '/policies/new': 'Create Policy',
    '/policies/compliance': 'Policy Compliance',
    '/policies/my-policies': 'My Policies',
    '/training': 'Training Courses',
    '/training/new': 'Create Course',
    '/training/dashboard': 'Training Dashboard',
    '/my-certifications': 'My Certifications',
    '/access': 'Access Dashboard',
    '/access/systems': 'System Registry',
    '/access/requests': 'Access Requests',
    '/access/offboarding': 'Offboarding',
    '/access/roles': 'Role Templates',
    '/compliance': 'Compliance Overview',
    '/compliance/employees': 'Employee Records',
    '/compliance/gaps': 'Gap Analysis',
    '/settings': 'Settings',
    '/billing': 'Billing',
};

export function RouteAnnouncer() {
    const location = useLocation();
    const [announcement, setAnnouncement] = useState('');

    useEffect(() => {
        const title = ROUTE_TITLES[location.pathname];
        if (title) {
            setAnnouncement(`Navigated to ${title}`);
            document.title = `${title} — u-Compliance`;
        } else {
            // Handle dynamic routes like /documents/:id
            const segments = location.pathname.split('/').filter(Boolean);
            const fallback = segments
                .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
                .join(' — ');
            setAnnouncement(`Navigated to ${fallback}`);
            document.title = `${fallback} — u-Compliance`;
        }
    }, [location.pathname]);

    return (
        <div
            role="status"
            aria-live="polite"
            aria-atomic="true"
            className="sr-only"
        >
            {announcement}
        </div>
    );
}